import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import CatalogList from "../screens";

export const CatalogRoutes: IAllPrivateRoutes[] =
  process.env.REACT_APP_PAPS_PRODUCTS_CHECK === "false"
    ? [{ label: "Catalog", pathName: "/catalog", routeElement: CatalogList, roles: user.roles }]
    : [];
